import { RedirectToClassic } from '../../Common/RedirectToClassic'

export const ApplicationManagement = () => <RedirectToClassic />
